export default __webpack_public_path__ + "static/media/Ballroll_00138.ae420d41.png";